import React from "react";
import { Mail } from "lucide-react";
import footer from "../../Assets/img/footer.png";

const Footer = () => {
  return (
    <footer className="bg-[#0f0f0f] text-white rounded-t-3xl px-6 md:px-16 lg:px-28 pt-20 pb-5">
      <div className="mx-auto max-w-7xl">
        {/* Top Section */}
        <div className="grid gap-10 mb-16 md:grid-cols-5">
          {/* Left Column */}
          <div className="space-y-6 md:col-span-2">
            <div className="flex items-center gap-3">
              <img src={footer} alt="verified" className="w-[320px] h-[49px]" />
            </div>

            <p className="text-sm leading-relaxed text-gray-400 md:text-base">
              Chorus One is one of the biggest institutional staking providers
              operating on 40+ Proof-of-Stake networks including Ethereum,
              Solana, and Cosmos among others.
            </p>
          </div>

          {/* Link Columns */}
          <div className="space-y-4">
            <h5 className="text-sm text-gray-400 uppercase">About</h5>
            <ul className="space-y-2">
              <li>About Chorus One</li>
              <li className="text-teal-400">Chorus One Ventures</li>
              <li>Contact Us</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h5 className="text-sm text-gray-400 uppercase">
              Stake with Chorus One
            </h5>
            <ul className="space-y-2">
              <li>ETH Staking Vault</li>
              <li>Whitelabel Validators</li>
              <li>Public Nodes</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h5 className="text-sm text-gray-400 uppercase">Protocols</h5>
            <ul className="space-y-2">
              <li>Ethereum</li>
              <li>Cosmos</li>
              <li>Solana</li>
              <li>Avalanche</li>
              <li>Near</li>
              <li>View All</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h5 className="text-sm text-gray-400 uppercase">Resources</h5>
            <ul className="space-y-2">
              <li>Research</li>
              <li>Blog</li>
              <li>MEV</li>
              <li>Podcast</li>
              <li>Staking Guides</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h5 className="text-sm text-gray-400 uppercase">Follow Us</h5>
            <ul className="space-y-2">
              <li>Twitter</li>
              <li>LinkedIn</li>
              <li>YouTube</li>
              <li>Telegram</li>
              <li>Discord</li>
              <li>Github</li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="pt-6">
            <h4 className="mb-3 text-lg font-semibold">
              Subscribe to our newsletter
            </h4>
            <form className="flex items-center max-w-md gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 text-black rounded-md focus:outline-none focus:ring-2 focus:ring-teal-400"
              />
              <button
                type="submit"
                className="flex items-center gap-2 px-4 py-3 text-white transition bg-teal-500 rounded-md hover:bg-teal-600"
              >
                <Mail size={16} /> Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col justify-between gap-4 pt-6 text-sm text-gray-400 border-t border-gray-700 md:flex-row">
          <p>© 2025 Chorus One</p>
          <div className="flex flex-wrap gap-6">
            <span>Cookie Policy</span>
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
            <span>Consent Preferences</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
